import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Row, Tooltip } from "antd";
import { useLoading } from "../../context/loadingContext";
import dayjs from "dayjs";
import SearchDatePicker from "../../components/search/datePicker";
import { FilterOutlined, RedoOutlined } from "@ant-design/icons";
import { useAdmin } from "../../context/adminContext";
import moneyFormat from "../../functions/utils/moneyFormat";
import GetBankTransactionLog from "functions/admin/getBankTransactionLog";
import { useParams } from "react-router-dom";
import SearchAdmin from "components/search/searchAdmin";
import { bg_button, bg_shadow } from "constant/css";
import TablePagination from "components/pagination/tablePagination";

const BankTransactionLog = () => {
  const { account } = useParams();

  const { showLoading, hideLoading } = useLoading();
  const { searchFields, setSearchFields, showFilter, setShowFilter } =
    useAdmin();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  useEffect(() => {
    prepareQueryStringAndSearch();
  }, [page, pageSize]);

  useEffect(() => {
    if (page === 1) prepareQueryStringAndSearch();
    else setPage(1);
  }, [searchFields, account]);
  const prepareQueryStringAndSearch = () => {
    //object fields length

    const searchFieldsLength = Object.keys(searchFields).length;
    var queryString = ``;
    if (searchFieldsLength !== 0) {
      queryString = Object.keys(searchFields)
        .map((key) => {
          if (!searchFields[key]) return;
          if (key.includes("At") || key.includes("Date")) {
            // it is date
            return `${key}=${searchFields[key]
              .map((e, i) => {
                if (i == 0)
                  return dayjs(e).startOf("day").format("YYYY-MM-DD HH:MM");
                return dayjs(e).endOf("day").format("YYYY-MM-DD HH:MM");
              })
              .join("->")}`;
          }
          return `${key}=${encodeURIComponent(searchFields[key])}`;
        })
        .join("&");
      fetchTransactionLogs(queryString, page, pageSize);
    } else fetchTransactionLogs("", page, pageSize);
  };
  const defaultColumns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 10,
    },
    {
      title: <span className="text-xs">Данс</span>,
      dataIndex: "accountNumber",
      key: "accountNumber",
      width: "10%",
    },
    {
      title: <span className="text-xs">Хүлээн авагч/ шилжүүлэгч</span>,
      dataIndex: "relatedAccount",
      key: "relatedAccount",
      width: "12%",
    },
    {
      title: (
        <SearchAdmin
          sort={false}
          title="Гүйлгээний утга"
          fieldName="description"
        />
      ),
      dataIndex: "description",
      key: "description",
      width: "32%",
      render: (e) => {
        const text = String(e).substring(0, 47);
        const isHighlighted =
          !String(text).toLowerCase().includes("xpay") &&
          !String(text).toLowerCase().includes("qpay") &&
          !String(text).toLowerCase().includes("merchant") &&
          !String(text).toLowerCase().includes("negdi");

        return (
          <Tooltip title={text}>
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              {isHighlighted ? (
                <Tag color="error" className="text-xs">
                  {text}
                </Tag>
              ) : (
                <span className="text-xs">{text}</span>
              )}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: <span className="text-xs">Дүн</span>,
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (e) => (
        <Tag color={e > 0 ? "cyan" : "warning"}>
          {moneyFormat(parseFloat(e))}
        </Tag>
      ),
      width: "10%",
    },
    {
      title: <span className="text-xs">Үлдэгдэл</span>,
      dataIndex: "remain",
      key: "remain",
      align: "right",
      render: (e) => moneyFormat(parseFloat(e)),
      width: "12%",
    },
    {
      title: (
        <SearchDatePicker
          title="Гүйлгээний огноо"
          datePicker
          fieldName="trnDate"
        />
      ),
      dataIndex: "trnDate",
      key: "trnDate",
      width: 120,
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD") : "-"),
    },
    {
      title: "Татсан огноо",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD HH:mm") : "-"),
    },
  ];
  useEffect(() => {
    refresh();
  }, []);
  const fetchTransactionLogs = async (queryString, page, size) => {
    showLoading();
    const response = await GetBankTransactionLog(
      `&accountNumber=${account}&page=${page}&size=${size}&${queryString}`
    );
    hideLoading();
    if (response) {
      setData(response.data);
      setPaginationData(response.pagination);
    }
  };
  const changePage = (page) => {
    setPage(page);
  };
  const changeSize = (current, size) => {
    setPageSize(size);
  };
  const refresh = () => {
    setPage(1);
    setSearchFields({});
    fetchTransactionLogs("", 1, pageSize);
  };
  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  return (
    <div className="vatMerchantListontainer mt-3">
      <Row style={{ gap: 10 }}>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button} rounded-xl ${bg_shadow}`}
            onClick={refresh}
          >
            <RedoOutlined />
          </Button>
        </div>
        <div className="addButtonMerchant">
          <Button
            type={"primary"}
            className={`spayDefaultButton ${bg_button} rounded-xl ${bg_shadow} ${
              !showFilter && "spayDefaultButtonInactive"
            }`}
            onClick={toggleFilter}
          >
            <FilterOutlined />
          </Button>
        </div>
      </Row>
      <div className="tableContainer">
        <Table
          columns={defaultColumns}
          rowKey={(record) => record.id}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 38vh)",
          }}
          size="small"
          pagination={false}
          dataSource={data}
          // summary={(pageData) => {
          //   return (
          //     <Table.Summary fixed>
          //       <Table.Summary.Row className="summaryRow">
          //         <Table.Summary.Cell index={0} colSpan={2} align="right">
          //           Нийт дүн:
          //         </Table.Summary.Cell>
          //         <Table.Summary.Cell index={1} colSpan={2} align="right">
          //           {summary ? moneyFormat(summary.totalAmount) : 0}
          //         </Table.Summary.Cell>
          //       </Table.Summary.Row>
          //     </Table.Summary>
          //   );
          // }}
        ></Table>
        <TablePagination
          paginationData={paginationData}
          page={page}
          changePage={changePage}
          changeSize={changeSize}
        />
      </div>
    </div>
  );
};

export default BankTransactionLog;
